<template>
  <div class="home">
    <list-page />
  </div>
</template>

<script>
// @ is an alias to /src
import ListPage from "@/components/page/HomeView/content/list-page.vue";

export default {
  name: "HomeView",
  components: { ListPage },
  mounted() {
    const {
      title = 'Эрхэм зорилго "Тикийн эсрэг Ноофен"',
      description = "Хүүхдэд тикийг даван туулж, өсөж том болоход нь туслаарай",
    } = this.$route.meta;

    document.title = title;
    let meta = document.querySelector("meta[name='description']");
    if (meta) {
      meta.setAttribute("content", description);
    } else {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.content = description;
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
